import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import type { KCloudLoginRequest, KCloudLoginResponse, ClientSyncRequest } from "@/features/accounts/account-group/services/kcloud-authenticate-model";

export const kCloudAuthenticateApi = {
  login: async (service: "kaikei" | "shokokai", request: KCloudLoginRequest): Promise<KCloudLoginResponse> => {
    const response = await ApiClient.instance.post<KCloudLoginResponse>({
      path: `/api/cloud_login/${service}`,
      params: request as NonNullable<unknown>,
    });
    
    if (response.ok === false) {
      throw MoneyLinkException.fromServer({ response: response });
    }
    
    return response.body;
  },

  selectClient: async (service: "kaikei" | "shokokai", request: ClientSyncRequest): Promise<void> => {
    const response = await ApiClient.instance.post<void>({
      path: `/api/cloud_syncclient/${service}`,
      params: request as NonNullable<unknown>,
    });
    
    if (response.ok === false) {
      throw MoneyLinkException.fromServer({ response: response });
    }
  },
};
